module.exports = __webpack_public_path__ + "img/notros.4f94d46f.png";